import { useEffect } from "react";
import { applyMeta, injectJsonLd, removeJsonLd } from "@/seo/seoService";

/**
 * SeoHead ,  applies meta tags + optional JSON-LD blocks.
 * Mount once per page. Pass schemas as { id, data }.
 */
export default function SeoHead({ title, description, path, ogImage, keywords, geoRegion, geoPlacename, noIndex, schemas = [] }) {
  useEffect(() => {
    applyMeta({ title, description, path, ogImage, keywords, geoRegion, geoPlacename, noIndex });
    schemas.forEach((s) => injectJsonLd(s.id, s.data));
    return () => {
      schemas.forEach((s) => removeJsonLd(s.id));
    };
  }, [title, description, path, ogImage, keywords, geoRegion, geoPlacename, noIndex, schemas]);
  return null;
}
